import { defineComponent as a, openBlock as t, createBlock as d, createCommentVNode as l } from "vue";
import m from "./variants/Countdown.vue2.js";
const r = /* @__PURE__ */ a({
  name: "RevCounter",
  __name: "Counter",
  props: {
    ariaLabel: {},
    date: {},
    dateMaxUnit: { default: "hours" },
    dateLabels: {},
    size: { default: "medium" },
    mood: { default: "main" }
  },
  setup(e) {
    return (n, i) => e.date ? (t(), d(m, {
      key: 0,
      "aria-label": e.ariaLabel,
      date: e.date,
      labels: e.dateLabels,
      "max-unit": e.dateMaxUnit,
      mood: e.mood,
      size: e.size
    }, null, 8, ["aria-label", "date", "labels", "max-unit", "mood", "size"])) : l("", !0);
  }
});
export {
  r as default
};
